import enGB from "antd/locale/en_GB";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";
import frCA from "antd/locale/fr_CA";
import frFR from "antd/locale/fr_FR";
import jaJP from "antd/locale/ja_JP";

import type { Locale } from "antd/es/locale";
import type { i18n as I18nInstance } from "i18next";

// Map i18next language codes to Ant Design locale objects
const antdLocales: Record<string, Locale> = {
  en: enGB,
  fr: frCA,
  es: esES,
  jp: jaJP,
  "en-US": enUS,
  "en-GB": enGB,
  "en-CA": enGB,
  "fr-FR": frFR,
  "fr-CA": frCA,
  "es-ES": esES,
  "ja-JP": jaJP,
};

export const getAntdLocale = (i18n: I18nInstance): Locale => {
  const language = i18n.language;
  const fallbackLng = i18n.options.fallbackLng;

  if (language && antdLocales[language]) {
    return antdLocales[language];
  }

  if (Array.isArray(fallbackLng) && fallbackLng.length > 0 && antdLocales[fallbackLng[0]]) {
    return antdLocales[fallbackLng[0]];
  }

  return enGB;
};
